import { Component, Input, OnChanges, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import { map, Observable, startWith } from 'rxjs';
import { Document } from 'app/models/dto/document.model';
import { DocumentCategory } from 'app/models/dto/document-category.model';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-document-category',
    templateUrl: './document-category.component.html',
    styleUrls: ['./document-category.component.scss']
})
export class DocumentCategoryComponent implements OnChanges, OnInit {

    @Input() set doc(d: Document) {
        this.document = d;
    };
    @Input() documentCategories: DocumentCategory[];
    @Output() updateDocCategory = new EventEmitter<any>();

    document: Document;
    filteredOptions: Observable<DocumentCategory[]>;
    categoryControl = new UntypedFormControl('');

    constructor() { }

    ngOnInit() {
        this.filteredOptions = this.categoryControl.valueChanges.pipe(
            startWith(''),
            map(value => this.filterCategories(value || '')),
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.doc || changes.documentCategories) {
            if (!!this.document) {
                this.categoryControl.setValue(this.getCategoryName(this.document.category));
            }
        }
    }

    disableDocCategory(document: Document) {
        return ['VERIFYING', 'QUEUED', 'PROCESSING'].includes(document.ocrolusStatus) || document.ocrolusDocTypeVerified === 1;
    }

    handleDocCategory(document: Document, update: { type: string, value }) {
        const category = this.documentCategories.find(item => item.name === update.value || null);
        update.value = category?.id;
        this.updateDocCategory.emit({ document, update });
    }

    ocrolusDocTypeTooltip(document: Document): string | null {
        if (document.ocrolusDocTypeVerified === null) {
            return null;
        }

        if (document.ocrolusDocTypeVerified === 1) {
            return `Document category "${this.documentCategories.find(c => c.id === document.category)?.name}" verified by Ocrolus`;
        }

        if (document.ocrolusFormType === 'UNKNOWN') {
            return 'Document category marked unknown by Ocrolus';
        }

        if (document.ocrolusStatus === 'REJECTED') {
            return 'Document was rejected by Ocrolus and category could not be verified';
        }

        return null;
    }

    private getCategoryName(category: string) {
        if (this.documentCategories.length > 0) {
            return this.documentCategories.filter(cat => cat.id === category)[0]?.name;
        }
    }

    private filterCategories(value: string): DocumentCategory[] {
        const filterValue = value.toLowerCase();
        return this.documentCategories.filter(option => option.name.toLowerCase().includes(filterValue));
    }
}
